import { useEffect } from "react";
import { useUploadStore } from "../../store/uploadStore";
import {
  floatingBarSelectors,
  useCurrentFloatingItem,
  useFloatingBarStore,
} from "../../store/floatingBarStore";

/**
 * Upload Store 상태를 동기화하고 관리하는 훅
 */
export const useUploadStoreSync = () => {
  const items = useUploadStore((s) => s.items);
  const floatingBarState = useFloatingBarStore(floatingBarSelectors.floatingBar);
  const currentFloatingItem = useCurrentFloatingItem();
  const cleanupOldItems = useUploadStore((s) => s.cleanupOldItems);

  // 앱 시작 시 오래된 아이템 정리
  useEffect(() => {
    cleanupOldItems();
  }, [cleanupOldItems]);

  return {
    items,
    floatingBarState,
    currentFloatingItem,
  };
};
